<template>
  <v-row justify="center">
    <v-dialog scrollable max-width="1600" v-model="showDialog">
      <template v-slot:activator="{ on }">
        <div class="my-2">
          <v-icon disabled v-on="on" @click="actualizar">edit</v-icon>
        </div>
      </template>
      <v-card v-if="loading" max-width="1600" max-height="80%">
        <v-card-title>
          <h4 v-if="loading">cargando . . .</h4>
        </v-card-title>
      </v-card>
      <v-card max-width="1600" height="80%" v-if="lista && !loading">
        <v-card-title>
          <h4>Selecciona una factura</h4>
        </v-card-title>
        <v-card-text>
          <v-container
            id="scroll-target"
            class="overflow-y-auto"
            style="max-width: 1500px"
          >

            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">FacturaId</th>
                    <th class="text-left">NumeroFactura</th>
                    <th class="text-right">Monto Factura</th>
                    <th class="text-left">CodMemSq</th>
                    <th class="text-left">NumeroCedula</th>
                    <th class="text-left">Nombres</th>
                    <th class="text-left">OrdenPagoId</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detalle in lista" :key="detalle.facturaId">
                    <td>{{ detalle.facturaId }}</td>
                    <td>{{ detalle.numeroFactura }}</td>
                    <td class="text-right">
                      {{ detalle.montoFactura | numberFormat }}
                    </td>
                    <td>{{ detalle.codMemSq }}</td>
                    <td>{{ detalle.numeroCedula }}</td>
                    <td>{{ detalle.nombres }}</td>
                    <td>{{ detalle.ordenPagoId }}</td>
                    <td>
                      <v-btn
                        small
                        @click="confirmar(detalle)"
                        >Seleccionar</v-btn
                      >
                    </td>
                    <!-- <td><v-btn small color="primary" v-if="pago.estado=='Validado'">Anular</v-btn></td> -->
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="info" @click="volver">Volver</v-btn>
        </v-card-actions>
        <span class="red--text">{{ errorMessage }}</span>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import axios from "axios";
import numeral from "numeral";

export default Vue.extend({
  props: ["pagoDetalleId","ordenPagoId"],
  data() {
    return {
      loading: false,
      showDialog: false,
      errorMessage: "",
      descripcion: "",
      lista: [],
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      validForm: false,
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$refs.form.reset();
      this.showDialog = false;
    },
    confirmar(detalle) {
      //detalle.ordenPagoId, detalle.monto, detalle.numeroCuenta, detalle.medioPagoId
      this.busqueda = "";
      //this.showDialog = false;

      this.errorMessage = '';
      axios
        .post(`/pagoDetalle/${this.pagoDetalleId}/actualizarFactura/${detalle.facturaId}`)
        .then(response => {
          console.log(response);
          this.$emit('nuevaFactura', {...detalle, pagoDetalleId: this.pagoDetalleId})
          this.showDialog = false;
        })
        .catch(err => {
          this.loading = false;
          this.nuevaCedula = this.cedula;
          console.log(err);
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });




    },
    volver() {
      this.busqueda = "";
      this.showDialog = false;
    },
    actualizar() {
      this.loading = true;

      axios
        .get("/ordenPago/" + this.ordenPagoId + "/facturasAsignables")
        .then((response) => {
          this.lista = response.data;
          this.loading = false;
          // console.log(response.data);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });        
    },
  },
  filters: {
    numberFormat(value) {
      if (value) {
        return numeral(value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
});
</script>
<style scoped>
.blue {
  color: lightblue;
}
</style>